import React from 'react';

import HighchartsReact from 'highcharts-react-official';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconExpandLess, iconExpandMore } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { InfoOtherSource } from './components/InfoOtherSource';
import { useBarChart } from './hooks/useBarChart';

type BarChartParams = {
	allChannels: Parameters<typeof useBarChart>[0];
	otherSignatureSource?: { signaturePercent: number };
};

export function BarChart({ allChannels, otherSignatureSource }: BarChartParams): React.JSX.Element | null {
	const {
		data: { options, isShowingAllChannels, showButtons, highchartsModule },
		actions,
	} = useBarChart(allChannels);

	if (allChannels.length === 0) return null;

	return (
		<Box as="section" data-qa="signature-sources-bar-chart">
			<HighchartsReact highcharts={highchartsModule} options={options} />
			{!showButtons && otherSignatureSource ? (
				<InfoOtherSource signaturePercent={otherSignatureSource.signaturePercent} />
			) : null}
			{showButtons &&
				(isShowingAllChannels ? (
					<>
						{otherSignatureSource ? <InfoOtherSource signaturePercent={otherSignatureSource.signaturePercent} /> : null}
						<Button
							size="small"
							icon={iconExpandLess}
							iconPosition="end"
							variant="secondary"
							data-qa="signature-source-view-less"
							sx={{
								width: '100%',
							}}
							mt={8}
							mb={0}
							onClick={() => {
								actions.showTopChannels();
							}}
						>
							<Translate value="corgi.petition.starter_dashboard.petition_insights.signature_sources.view_less_button" />
						</Button>
					</>
				) : (
					<Button
						size="small"
						icon={iconExpandMore}
						iconPosition="end"
						variant="secondary"
						data-qa="signature-source-view-more"
						sx={{
							width: '100%',
						}}
						mt={8}
						mb={0}
						onClick={() => {
							actions.showAllChannels();
						}}
					>
						<Translate value="corgi.petition.starter_dashboard.petition_insights.signature_sources.view_more_button" />
					</Button>
				))}
		</Box>
	);
}
